import { render, staticRenderFns } from "./AamsRegSealDisposalRecord.vue?vue&type=template&id=5d1e0e59&scoped=true&"
import script from "./AamsRegSealDisposalRecord.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealDisposalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e0e59",
  null
  
)

export default component.exports